import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import { pinPosition } from "../util"
import PlanetOne from "../3d/PlanetOne"
import PlanetTwo from "../3d/PlanetTwo"
import PlanetThree from "../3d/PlanetThree"
import Hands from "../3d/Hands"
import useStore from "../AppStore"
import Planet from "../3d/Planet"

export default function ScenePlanetHands(props) {
  
  const groupRef = useRef(null)
  const handsRef = useRef(null)
  const planetsRef = useRef(null)
  const planet1Ref = useRef(null)
  const planet2Ref = useRef(null)
  const planet3Ref = useRef(null)
  const planet4Ref = useRef(null)
  
  useFrame(({clock}) => {

    const top = useStore.getState().top

    handsRef.current.rotation.order = 'YZX'
    handsRef.current.rotation.x = -2
    handsRef.current.rotation.y = Math.sin(clock.elapsedTime*0.3) * 1 - 0.5 - top * 0.01
    handsRef.current.rotation.z = Math.PI * 1. + Math.sin(clock.elapsedTime*0.7) * 0.2 - 0.1

    planetsRef.current.rotation.z = Math.sin(clock.elapsedTime*0.7) * 0.2 - 0.1
    planet1Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 1
    planet2Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 0.4
    planet3Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 0.4
    planet4Ref.current.rotation.y = -top * 0.005 - clock.elapsedTime * 1

  })
  
  return(
    <group ref={groupRef} {...props}>
      <group ref={handsRef} scale={[1,1,1]}>
        <Suspense fallback={null}>
          <Hands position={[-5,0,0]} rotation={[-0.9,0.3,0]}/>
          <Hands position={[5,0,0]}  rotation={[-0.3,Math.PI*1.8,0]} scale={[-1,1,1]} />
        </Suspense>
      </group>
      <group ref={planetsRef}>
        <group ref={planet1Ref}>
          <PlanetOne position={[2,0,0]} scale={[0.8,0.8,0.8]} />
        </group>
        <group ref={planet2Ref}>
          <PlanetTwo position={[1,2,0]} scale={[0.8,0.8,0.8]} />
        </group>
        <group ref={planet3Ref}>
          <PlanetThree position={[0,-2,1]} scale={[1,1,1]} emission={8} />
        </group>
        <group ref={planet4Ref} scale={[0.5,0.5,0.5]}>
          <Planet position={[-4,0,0]} velo={10}/>
        </group>
      </group>
    </group>
  )
}
